import React from "react";
import { Button } from "antd";
import classes from "./ComingSoon.module.css";
import { HiArrowLeft } from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/LightLogo.webp";

const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className={classes.backTitle} onClick={() => navigate("/lajmet")}>
        <div
          className={classes.circleButton}
          onClick={() => navigate("/lajmet")}
        >
          <HiArrowLeft fontSize="1.2rem" color="white" />
        </div>
        <h2>Rikthehuni ne faqe</h2>
      </div>
      <div className={classes.headerLogo}>
        <img src={logo} alt="logoImage" />
      </div>
      <div className={classes["coming-soon-container"]}>
        <div className={classes["coming-soon-content"]}>
          <h1 className={classes["coming-soon-title"]}>Së shpejti...</h1>
          <p className={classes["coming-soon-text"]}>
            Së shpejti do të keni mundësi të reklamoni biznesin tuaj.
          </p>
        </div>
      </div>
    </>
  );
};

export default ComingSoon;
